import React from 'react'
import { localDate } from '../../utils/date'
import { Element } from 'react-bulma-components'

interface AutoClockingPreviewProps {
  autoClocking?: { enabled?: boolean; from?: Date | null; to?: Date | null } | null
}

const AutoClockingPreview: React.FC<AutoClockingPreviewProps> = ({ autoClocking }) => {
  if (!autoClocking?.enabled) return <Element renderAs="p">L'auto-pointage est désactivé.</Element>

  const from = autoClocking.from || undefined
  const to = autoClocking.to || undefined

  if (from && to)
    return (
      <>
        Actif du {localDate(from)} au {localDate(to)}.
      </>
    )
  if (from && !to) return <>Actif a partir du {localDate(from)} (sans date de fin).</>
  if (!from && to) return <>Actif jusqu'au {localDate(to)}.</>

  return <>Actif sans limite de dates.</>
}

export default AutoClockingPreview
